
import { Vue } from "vue-class-component";

export default class BoxOpened extends Vue {}
